<template>
  <component :is="isLayout"></component>
</template>
<script>
import GeneralLayout from "@/layout/GeneralLayout.vue";
import AccountLayout from "@/layout/AccountLayout.vue";
import { useRoute } from "vue-router";
import { computed, inject, onMounted, ref } from "vue";
export default {
  components: {
    GeneralLayout,
    AccountLayout,
  },
  setup() {
    const swal = inject("$swal");
    const route = useRoute();
    const isLayout = computed(() => {
      let routes = route.meta.layout;
      return `${routes}Layout`;
    });
    const isSafari = ref(false);
    const layoutName = computed(() => {
      return route.name;
    });

    onMounted(() => {
      const ua = navigator.userAgent;

      // Detect real Safari (exclude Chrome, Chromium, and iOS variants)
      if (/Safari/.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|EdgiOS/.test(ua)) {
        isSafari.value = true;
      }

      if (isSafari.value) {
        swal.fire({
          icon: "info",
          title: "Browser Compatibility Notice",
          html: `We detected that you’re using <b>Safari</b>.
      Some features may not work properly.
      For the best experience, we recommend using <b>Google Chrome</b>.`,
          confirmButtonText: "Understood",
          confirmButtonColor: "#f59e0b",
        });
      }
    });

    return {
      isLayout,
      layoutName,
      isSafari,
    };
  },
};
</script>
